import './modules/swiper.js'
import './modules/menu-toggle.js'
import './modules/menu-resize.js'
import './modules/newsletter.js'
import './modules/select-simulador.js'
import './modules/aos.js'
